import InstallPromptLocation from '@alltrails/amplitude/enums/InstallPromptLocation';
import InstallPromptSource from '@alltrails/amplitude/enums/InstallPromptSource';
import InstallPromptTrigger from '@alltrails/amplitude/enums/InstallPromptTrigger';
import InstallPromptType from '@alltrails/amplitude/enums/InstallPromptType';
import logInstallPromptClicked from '@alltrails/amplitude/events/logInstallPromptClicked';

export const iosAppStoreUrl = 'https://apps.apple.com/us/app/alltrails-hike-bike-run/id405075943';
export const androidAppStoreUrl = 'https://play.google.com/store/apps/details?id=com.alltrails.alltrails';

export const deepLinkRedirect = (
  deeplink: string,
  promptType: InstallPromptType,
  promptLocation: InstallPromptLocation,
  promptSource: InstallPromptSource,
  promptTrigger?: InstallPromptTrigger
) => {
  logInstallPromptClicked({
    install_prompt_type: promptType,
    install_prompt_location: promptLocation,
    install_prompt_source: promptSource,
    install_prompt_trigger: promptTrigger
  });

  window.location.assign(deeplink);
};
